import Immutable from 'immutable';
import EventsConstants from '../../constants/EventsConstants';

const initialState = Immutable.fromJS({
  id: null,
  isFetching: false,
  event: {},
  settings: {},
  relatedEventsByProgram: {},
  relatedEventsByAudience: {},
  eventsInSeries: {}
});

export default function EventsDetailsReducer(state = initialState, action) {
  switch (action.type) {
    case EventsConstants.EVENT_BY_ID_REQUEST: {
      return state.merge({
        isFetching: true
      });
    }

    case EventsConstants.EVENT_BY_ID_SUCCESS: {
      return state.merge({
        id: action.payload.event.id,
        event: Immutable.fromJS(action.payload.entities.event[action.payload.event.id]),
        isFetching: false
      });
    }

    case EventsConstants.EVENT_BY_ID_FAILURE: {
      return state.merge({
        isFetching: false
      });
    }

    case EventsConstants.EVENTS_SETTINGS_SUCCESS: {
      return state.merge({
        settings: Immutable.fromJS(action.payload.libraryInfo)
      });
    }

    case EventsConstants.EVENT_REGISTRATION_SUCCESS: {
      const eventRegistration = Object.values(action.payload.entities.eventRegistration);
      const numberAttending = eventRegistration[0].numberAttending;
      const totalRegistered = state.getIn(['event', 'numberRegistered']) + numberAttending;
      const newEvent = state.get('event').set('numberRegistered', totalRegistered);
      return state.merge({
        event: newEvent
      });
    }

    case EventsConstants.SEARCH_EVENTS_BY_PROGRAM_SUCCESS: {
      return state.merge({
        relatedEventsByProgram: Immutable.fromJS({
          eventIds: action.payload?.events?.results,
          events: action.payload?.entities?.events,
          count: action.payload?.events?.pagination?.count ?? 0
        })
      });
    }

    case EventsConstants.SEARCH_EVENTS_BY_AUDIENCE_SUCCESS: {
      return state.merge({
        relatedEventsByAudience: Immutable.fromJS({
          eventIds: action.payload?.events?.results,
          events: action.payload?.entities?.events,
          count: action.payload?.events?.pagination?.count ?? 0
        })
      });
    }

    case EventsConstants.SEARCH_EVENTS_BY_SERIES_SUCCESS: {
      return state.merge({
        eventsInSeries: Immutable.fromJS({
          eventIds: action.payload?.events?.results,
          events: action.payload?.entities?.events,
          count: action.payload?.events?.pagination?.count ?? 0
        })
      });
    }

    default:
      return state;
  }
}
